import * as Diagram from "../../../../components/diagram";

const levelColumns = [
  {
    key: "醫師報告",
    isNumber: true,
    isSum: true,
  },
];

export const CheckArea = {
  label: "篩檢場域",
  key: "CheckArea",
  path: "AtriumFibrillation/CheckArea",
  api: "TCS_V_HeartSS01",
  render: (options) => <Diagram.AtriumFibrillation.CheckArea {...options} />,
  isColSum: true,
  isRowSum: true,
  isGroup: true,
  groupColumns: [
    {
      key: "篩檢場域",
      field: "篩檢場域",
      header: "",
    },
  ],
  filterColumns: [
    { key: "篩檢日期", type: "date" },
    { key: "匯入日期", type: "date" },
  ],
  dateRangeColumns: [
    { label: "篩檢日期", key: "篩檢日期" },
    { label: "匯入日期", key: "匯入日期" },
  ],
  levelColumns,
  columns: [],
};
